<template>
    <div class="empty-message">
        <!-- Image -->
        <img :src="image"
        v-if="image"
        class="img-fluid d-block mx-auto"
        style="width: 200px;" />

        <!-- Title -->
        <h4 class="text-center mt-4">
            {{ title }}
        </h4>

        <!-- Subtitle -->
        <p class="text-center" v-html="subtitle" v-if="subtitle"></p>
        
        <!-- Button -->
        <button v-if="buttonText && buttonAction" type="button" class="btn btn-link text-primary mx-auto d-block" @click="buttonAction">
            {{ buttonText }}
        </button>
    </div>
</template>

<script>
export default {
    props: [
        'image',
        'title',
        'subtitle',
        'buttonText',
        'buttonAction',
    ],
}
</script>